module.exports = __webpack_public_path__ + "static/spec-diagram-example-d38fe25c1fd307c9c8cf56c5f72c754e.png";